import ProfileHome from "@components/User/Profile";
import Dialog from "@hudson/ui/components/Dialogs/Simple";
import Button from "@hudson/ui/components/FormFields/Button";
import useContent from "@lib/use_content";
import { useState } from "react";

export default function ManageTripsLoggedIn(): JSX.Element | null {
  const { data } = useContent(["beManageTripsButton"]);
  const [showDialog, setShowDialog] = useState(false);

  return (
    <>
      <div>
        <Button
          className="p-1 text-lg"
          onClick={() => setShowDialog(true)}
          asLink
          textColorClass="text-gray-500"
        >
          {data?.content.beManageTripsButton}
        </Button>
      </div>
      <Dialog
        maxWidthClass="max-w-4xl"
        show={showDialog}
        onHide={() => setShowDialog(false)}
        pagePath="/user/profile"
      >
        <ProfileHome initialFrame="reservations" />
      </Dialog>
    </>
  );
}